import React from 'react';
import classNames from 'classnames/bind';
import { ChevronNormalDown } from "../../../icons";
import styles from './Arrow.css';
var cx = classNames.bind(styles);
export var Arrow = function Arrow(_ref) {
  var classes = _ref.classes,
      onClick = _ref.onClick,
      view = _ref.view,
      inverted = _ref.inverted,
      inside = _ref.inside,
      icon = _ref.icon,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cx('root', "view_".concat(view), {
      inverted: inverted,
      inside: inside
    }, className, classes === null || classes === void 0 ? void 0 : classes.root),
    onClick: onClick
  }, icon || /*#__PURE__*/React.createElement(ChevronNormalDown, null));
};